import gql from 'graphql-tag';

export const PRODUCT_GBB_CONTENT_QUERY = gql`
  query getProductGBBContent {
    recommendationQueries {
      toolTips(productType: "tires") {
        key
        value
      }
    }
  }
`;
